module.exports = __webpack_public_path__ + "static/media/checkered-diamond-000000.6b919503.svg";